export default __webpack_public_path__ + "static/media/IMG_3896 - Copy.f709b4bd.jpg";